import { Description } from '@ui/sections/Description'

import {
  Wrapper,
  Content,
  ContentWrapper,
  Text,
  Title,
  Subtitle,
  TitleContainer,
} from './styles'
import { QuickFactsProps } from './types'

export function QuickFacts({
  sectionTitle,
  subtitle,
  items,
  borderColor,
}: QuickFactsProps) {
  return (
    <Wrapper className="facts-wrapper">
      <Description id={sectionTitle} title={sectionTitle} subtitle={subtitle} />
      <ContentWrapper
        className="content-wrapper"
        $numBlocks={items.length}
        $borderColor={borderColor}
      >
        {items.map(
          ({ id, title, text, titleColor, textColor, reversed, subtitle }) => (
            <Content key={id} $reversed={reversed} className="content">
              <TitleContainer>
                <Title className="title" as="h3" $color={titleColor}>
                  {title}
                </Title>
                {subtitle && (
                  <Subtitle className="subtitle" $color={titleColor}>
                    {subtitle}
                  </Subtitle>
                )}
              </TitleContainer>
              <Text className="text" $color={textColor}>
                {text}
              </Text>
            </Content>
          )
        )}
      </ContentWrapper>
    </Wrapper>
  )
}
